import React from 'react';
import ImageUploading from "react-images-uploading";

//styles
import styles from "../AddBlog/AddBlog.module.css"

//images
import addIcon from "../../../../assets/img/DashboardICons/CircleAddIconBlue.svg"
import trashIcon from "../../../../assets/img/DashboardICons/TrashIcon.svg"

const EditBlogImg = (props) => {
    const maxNumber = 1;
    const onChange = (imageList) => {
        props.setImages(imageList);
    };
    return (
        <>
            <div className={`w-100 mt-2 d-flex justify-content-center align-items-center flex-wrap ${styles.img_container}`} >
                <ImageUploading
                    multiple
                    value={props.images}
                    onChange={onChange}
                    maxNumber={maxNumber}
                    dataURLKey="data_url"
                >
                    {({
                        imageList,
                        onImageUpload,
                        onImageRemove,
                        dragProps
                    }) => (
                        <div className='w-100 d-flex align-items-center justify-content-center flex-wrap' {...dragProps}>
                            {imageList?.map((image, index) => (
                                <div key={index} className="w-100 position-relative d-flex flex-column align-items-center justify-content-center m-0">
                                    <img className={styles.uploaded_img} src={image['data_url']} alt="uploaded-img" />
                                    <div className={`d-flex align-items-center justify-content-center ${styles.remove_img_container}`}>
                                        <img onClick={() => onImageRemove(index)} src={trashIcon} alt="icon" />
                                    </div>
                                </div>
                            ))}

                            {props.images == ""
                                ?
                                <div className="d-flex align-items-center justify-content-center">
                                    <div className="d-flex align-items-center justify-content-center position-relative pointer" onClick={onImageUpload}>
                                        <img className="ms-2" src={addIcon} alt="icon" />
                                        <div className={styles.text_primary}>
                                            افزودن عکس مقاله
                                        </div>
                                    </div>
                                </div>
                                :
                                <></>
                            }
                        </div>
                    )}
                </ImageUploading>
            </div>
        </>
    );
};

export default EditBlogImg;